import { createFilterOptions, FilterOptionsState } from "@mui/material";
import { kebabCase } from "lodash";
import { Code } from "../../types/code";

export const ATTACHMENTS_MODALITY_SYSTEM =
  "http://medialhealth.com/CodeSystem/media-modality";

export type CreatableAttachmentsModalityOption = Code & {
  isCreatable?: boolean;
};

const modalityFilter =
  createFilterOptions<CreatableAttachmentsModalityOption>();

/**
 * Local free-option filter for attachment modality: keeps matching options and
 * appends an "Add …" creatable row when the typed value is new.
 */
export function filterAttachmentsModalityOptions(
  options: CreatableAttachmentsModalityOption[],
  params: FilterOptionsState<CreatableAttachmentsModalityOption>,
): CreatableAttachmentsModalityOption[] {
  const filtered = modalityFilter(options, params);
  const { inputValue } = params;
  const trimmed = inputValue.trim();

  if (!trimmed) return filtered;

  const isExisting = options.some(
    (option) => option.display?.toLowerCase() === trimmed.toLowerCase(),
  );

  if (isExisting) return filtered;

  filtered.push({
    system: ATTACHMENTS_MODALITY_SYSTEM,
    code: kebabCase(`other-${trimmed}`),
    display: `Add "${trimmed}"`,
    isCreatable: true,
  });

  return filtered;
}

export function createAttachmentsModalityFreeOptionValue(
  display: string,
): CreatableAttachmentsModalityOption {
  const trimmed = display.trim();
  return {
    system: ATTACHMENTS_MODALITY_SYSTEM,
    code: kebabCase(`other-${trimmed}`),
    display: trimmed,
  };
}
